import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const DeletePopUp = ({ show, handleDeleteItem, handleClose}) => {
    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header  className='orange-bg text-white'>
                <Modal.Title>Delete Item !!!</Modal.Title>
            </Modal.Header>
            <Modal.Body className='py-5 fs-4 fw-bold text-center'> Are you sure to delete the item ?</Modal.Body>
            <Modal.Footer className='d-flex flex-row justify-content-between align-items-center'>
                <Button onClick={handleDeleteItem} className='orange-bg text-white px-4 py-2'>
                    Yes
                </Button>
                <Button variant="info" onClick={handleClose}  className='px-4 py-2'>
                    No
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default DeletePopUp
